// src/components/home/TopTabsWeb.jsx
import React, {useState} from 'react';
import {StyleSheet, css} from 'aphrodite';

import {useDeliveryMode} from '../../context/DeliveryModeContext';

const tabs = ['Delivery', 'Pick-up', 'Dine-in'];

const TopTabsWeb = ({onSelect, selectedTab}) => {
  const {mode, changeMode} = useDeliveryMode();
  const [internalActiveTab, setInternalActiveTab] = useState(mode || 'Delivery');

  const activeTab = selectedTab || mode || internalActiveTab;

  const handleClick = tab => {
    setInternalActiveTab(tab);
    changeMode(tab);

    if (onSelect) {
      onSelect(tab);
    }
  };

  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.container)}>
        {tabs.map(tab => {
          const isActive = activeTab === tab;

          return (
            <button
              key={tab}
              type="button"
              className={css(styles.tabButton, isActive && styles.activeTab)}
              onClick={() => handleClick(tab)}>
              <span
                className={css(
                  styles.tabText,
                  isActive && styles.activeTabText,
                )}>
                {tab}
              </span>

              {isActive && <span className={css(styles.activeIndicator)} />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
  },

  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px',
    backgroundColor: '#FFF8EC',
    border: '1px solid #E6D8BE',
    borderRadius: '22px',
    boxSizing: 'border-box',
    overflowX: 'auto',

    '@media (max-width: 640px)': {
      gap: '10px',
      padding: '6px',
      borderRadius: '18px',
    },
  },

  tabButton: {
    position: 'relative',
    flex: 1,
    minWidth: '120px',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: '18px',
    padding: '14px 16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',

    ':hover': {
      backgroundColor: '#F4EBD8',
    },

    '@media (max-width: 640px)': {
      minWidth: '110px',
      padding: '12px 14px',
      borderRadius: '16px',
    },
  },

  activeTab: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0 10px 22px rgba(30, 30, 30, 0.06)',
  },

  tabText: {
    fontSize: '14px',
    fontWeight: '800',
    color: '#6E6254',
    whiteSpace: 'nowrap',

    '@media (max-width: 640px)': {
      fontSize: '13px',
    },
  },

  activeTabText: {
    color: '#0F3D2E',
  },

  activeIndicator: {
    width: '34px',
    height: '4px',
    borderRadius: '999px',
    backgroundColor: '#C9A14A',
    marginTop: '10px',
  },
});

export default TopTabsWeb;